<template>
    <div :style="$vuetify.theme.dark ? 'background-color: var(--bg-dark);' : 'background-color: var(--bg-light);'">
        <v-toolbar flat class="mt-1 d-flex justify-center" :style="$vuetify.theme.dark ? 'background-color: var(--bg-dark);' : 'background-color: var(--bg-light);'">
            <div class="d-flex align-center">
                <v-btn depressed fab text small @click="prev">
                    <v-icon small> mdi-chevron-left </v-icon>
                </v-btn>
                <v-toolbar-title class="overline">
                    <h3>{{ formatDateFilter }}</h3>
                </v-toolbar-title>
                <v-btn fab depressed text small @click="next">
                    <v-icon small> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn 
                    depressed 
                    :dark="punches.length > 0 && !isLoading" 
                    color="primary" 
                    @click="openMonthlyReport()"
                    :disabled="!punches.length || isLoading"
                >
                    Ver Reporte 
                    <v-icon right>mdi-eye</v-icon>
                </v-btn>
            </div>
        </v-toolbar>
        <v-row>
            <v-col cols="12" md="4">
                <v-card class="pa-4 mx-2 mb-2" elevation="0" v-if="hasAdminPermission">
                    <v-autocomplete
                        class="pa-4"
                        :items="filteredComerciales"
                        v-model="selectedComercial"
                        item-text="nombreCompleto"
                        item-value="id"
                        :disabled="!filteredComerciales || filteredComerciales.length == 0"
                        :loading="!filteredComerciales || filteredComerciales.length == 0"
                        prepend-inner-icon="mdi-account"
                        hint="Selecciona un comercial para ver sus fichajes, por defecto se mostrara el de la cuenta logueada"
                        persistent-hint
                        :menu-props="{ maxHeight: '600' }"
                        label="Comercial"
                        clearable
                        @change="fetchPunches()"
                    >
                        <template #item="{ item }">
                            <v-row>
                                <v-col cols="8">
                                    {{ item.nombreCompleto }}
                                </v-col>
                                <v-col
                                    v-if="item.estado && !$vuetify.breakpoint.smAndDown"
                                    cols="4"
                                >
                                    <v-chip
                                        label
                                        :color="estadoComercial[item.estado]"
                                        medium
                                        class="d-flex justify-center overline"
                                    >
                                        {{ item.estado }}
                                    </v-chip>
                                </v-col>
                                <v-col
                                    v-if="item.estado && $vuetify.breakpoint.smAndDown"
                                    cols="1"
                                >
                                    <v-icon
                                        :color="estadoComercial[item.estado]"
                                        large
                                        class="d-flex justify-center overline"
                                    >
                                        mdi-circle
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </template>
                    </v-autocomplete>
                </v-card>
                <v-card elevation="0" class="pa-4 mx-2">
                    <PunchInClock/>
                </v-card>
            </v-col>
            <v-col cols="12" md="8">
                <PunchInMonthList/>
            </v-col>
        </v-row>
        <PDFView 
            :offer="offer" 
            parentRenderMutation="punchIn/fetchHtmlPunches" 
            parentDownloadMutation="punchIn/fetchPdfPunches"
        />
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import PunchInClock from './PunchInClock.vue'
import PunchInMonthList from './PunchInMonthList.vue'
import PDFView from '@/components/PDFView/PDFView.vue';

export default {
    name: 'PunchInView',
    data: () => ({
        tab: '0',
        offer: null,
        parentRenderMutation: null,

        estadoComercial: {
            ALTA: 'success',
            BAJA: 'warning',
            INACTIVO: 'error',
            VACACIONES: 'blue',
        },
    }),
    components: {
        PunchInClock,
        PunchInMonthList,
        PDFView,
    },
        computed: {
        filteredComerciales() {
            return this.comerciales.filter((comercial) => comercial.nombreCompleto != 'Por asignar');
        },
        dateFilter: {
            get() {
                return this.$store.state.punchIn.dateFilter;
            },
            set(value) {
                this.$store.commit('punchIn/dateFilter', value);
            }
        },
        selectedComercial: {
            get() {
                return this.$store.state.punchIn.commercial;
            },
            set(value) {
                if (value == null) {
                    value = JSON.parse(localStorage.getItem('cuenta')).id;
                }
                this.$store.commit('punchIn/commercial', value);
            }
        },
        formatDateFilter() {
            return `${this.dateFilter.toLocaleString('es-ES', { month: 'long' })}  ${this.dateFilter.getFullYear()}`;
        },
        ...mapState('punchIn', ['punches', 'isLoading']),
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
            hasComercialPermission: 'hasComercialPermission',
            hasAdminPermission: 'hasAdminPermission',
        }),
    },
    methods: {
        openMonthlyReport() {
            this.offer = undefined;

            let PDFView = {
                isLoadingHtmlOffer: true,
                isOpenViewDialog: true,
                ofertaHtml: '',
            };
            this.$store.commit('util/PDFView', PDFView);
        },
        prev() {
            const copy = this.dateFilter;
            copy.setDate(0);
            this.dateFilter = new Date(copy);
        },
        next() {
            const copy = this.dateFilter;
            copy.setMonth(this.dateFilter.getMonth() + 1, 1);
            this.dateFilter = new Date(copy);
        },
        exportPunches() {
            this.punches.forEach(element => {
                console.log(element);
                let day = element.date
                let first = element.punches[0]['IN']
                let last = element.punches[Object.keys(element.punches).length - 1]['OUT']

                console.log(first, last, date);
            });
            // this.$store.dispatch('punchIn/exportPunches');
        },
        ...mapActions('punchIn', ['fetchPunches']),
    },
    watch: {
        dateFilter() {
            this.fetchPunches()
        },
    },
    beforeMount(){
        this.fetchPunches()
        if (this.$store.state.teletrabajo.Comerciales.length === 0 && !this.hasComercialPermission) {
            this.$store.dispatch('teletrabajo/fetchComerciales')
        }
    }
}
</script>
